import React, { useState, useEffect } from "react";
import { X, Hammer } from "lucide-react";

/**
 * Beta / Work-in-progress banner.
 *
 * Visible on the public Landing page until the operator flips
 * `REACT_APP_SHOW_BETA_BANNER` to `"false"` in /app/frontend/.env (then redeploy).
 * Dismissed for the rest of the browser session via sessionStorage so it doesn't
 * harass repeat visitors during a single browsing window.
 */
export default function BetaBanner() {
  const enabled = (process.env.REACT_APP_SHOW_BETA_BANNER || "true").toLowerCase() !== "false";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    try {
      if (window.sessionStorage.getItem("errandday_beta_banner_dismissed") !== "1") {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, [enabled]);

  if (!enabled || !visible) return null;

  const dismiss = () => {
    try { window.sessionStorage.setItem("errandday_beta_banner_dismissed", "1"); } catch (err) { /* private mode */ console.warn("BetaBanner: sessionStorage write failed", err); }
    setVisible(false);
  };

  return (
    <div
      data-testid="beta-banner"
      className="relative w-full bg-[#F2A900] text-[#1a1208] border-b-2 border-[#1a1208]/10"
      role="status"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-3 flex items-center gap-3 text-sm md:text-base font-[600] pr-12">
        <Hammer className="w-5 h-5 shrink-0" aria-hidden="true" />
        <p className="leading-tight">
          <span className="uppercase tracking-[0.18em] text-xs mr-2 px-2 py-0.5 rounded-full bg-[#1a1208] text-[#F2A900]">Beta</span>
          ErrandDay is still being polished — we&apos;re running live tests with verified agents. Expect rough edges. Your feedback helps us launch confidently.
        </p>
      </div>
      <button
        onClick={dismiss}
        data-testid="beta-banner-dismiss"
        aria-label="Dismiss banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 rounded-full hover:bg-[#1a1208]/10 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
